export const loadScript = (id: string, url: string): Promise<void> => {
  const existingScript = document.getElementById(id);
  if (existingScript) {
    existingScript.remove();
  }
  const script = document.createElement("script");
  script.src = url;
  script.id = id;
  const loaded = new Promise<void>((resolve, reject) => {
    script.onload = (): void => resolve();
    script.onerror = (): void => reject(new Error(`Failed to load ${url}`));
  });
  document.body.appendChild(script);
  return loaded;
};
